import React, { useState } from 'react';
import {
  Box,
  Paper,
  Typography,
  TextField,
  Button,
  Alert,
  CircularProgress,
} from '@mui/material';
import { adminAPI } from '../../utils/api';

const ViewerCreate = ({ onViewerCreated }) => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    setSuccess(null);

    try {
      const result = await adminAPI.createViewer(email);
      setSuccess(result);
      setEmail('');

      if (onViewerCreated) {
        onViewerCreated();
      }
    } catch (err) {
      setError(err.message || 'Failed to create viewer');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Paper sx={{ p: 3 }}>
      <Typography variant="h6" gutterBottom>
        Create Assessment Viewer
      </Typography>

      {error && (
        <Alert severity="error" sx={{ mb: 2 }}>
          {error}
        </Alert>
      )}

      {success && (
        <Alert severity="success" sx={{ mb: 2 }}>
          <Typography variant="body2">
            Viewer created successfully!
          </Typography>
          <Typography variant="body2">
            <strong>Email:</strong> {success.email}
          </Typography>
          <Typography variant="body2">
            <strong>Password:</strong> {success.password}
          </Typography>
          <Typography variant="body2" color="error" sx={{ mt: 1 }}>
            ⚠️ Save this password - it won't be shown again!
          </Typography>
        </Alert>
      )}

      <Box component="form" onSubmit={handleSubmit}>
        <TextField
          label="Viewer Email"
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
          fullWidth
          sx={{ mb: 2 }}
        />

        <Button
          type="submit"
          variant="contained"
          disabled={loading}
          startIcon={loading && <CircularProgress size={20} />}
        >
          {loading ? 'Creating...' : 'Create Viewer'}
        </Button>
      </Box>
    </Paper>
  );
};

export default ViewerCreate;
